import type React from "react";
import {
	isNotificationGranted,
	isNotificationSupported,
	requestNotificationPermission,
} from "../../../../utils/browser-notification";

interface PreferenceNotificationsTabProps {
	notificationsEnabled: boolean;
	onUpdateNotificationsEnabled: (enabled: boolean) => Promise<void>;
}

export const PreferenceNotificationsTab: React.FC<
	PreferenceNotificationsTabProps
> = ({ notificationsEnabled, onUpdateNotificationsEnabled }) => {
	return (
		<div className="flex flex-col gap-8">
			<h3 className="m-0 mb-4 text-[1.1rem] text-primary border-b border-border-main pb-2">
				通知設定
			</h3>
			<div className="flex flex-col gap-3 bg-bg-main p-3 rounded-lg border border-border-main mb-3">
				<div className="flex items-center justify-between gap-4">
					<div className="flex flex-col gap-1">
						<label
							htmlFor="notification-toggle"
							className="text-sm font-medium text-text-main cursor-pointer"
						>
							コメント生成完了通知
						</label>
						<span className="text-xs text-text-dim">
							別のタブやアプリ使用中にコメントが届いたことをお知らせします
						</span>
					</div>
					<button
						id="notification-toggle"
						type="button"
						role="switch"
						aria-checked={notificationsEnabled}
						disabled={!isNotificationSupported()}
						className={[
							"relative inline-flex h-6 w-11 items-center rounded-full transition-all duration-200 active:scale-95",
							"focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-bg-main",
							"disabled:opacity-40 disabled:cursor-not-allowed",
							notificationsEnabled ? "bg-primary" : "bg-border-main",
						].join(" ")}
						onClick={async () => {
							const nextEnabled = !notificationsEnabled;
							if (nextEnabled) {
								const permission = await requestNotificationPermission();
								if (permission !== "granted") {
									return;
								}
							}
							await onUpdateNotificationsEnabled(nextEnabled);
						}}
					>
						<span
							className={[
								"inline-block h-4 w-4 rounded-full bg-white shadow transition-transform duration-200",
								notificationsEnabled ? "translate-x-6" : "translate-x-1",
							].join(" ")}
						/>
					</button>
				</div>
				{isNotificationSupported() && Notification.permission === "denied" && (
					<p className="text-xs text-amber-400 mt-1">
						⚠️
						通知がブラウザ設定でブロックされています。ブラウザのサイト設定から許可してください。
					</p>
				)}
				{!isNotificationSupported() && (
					<p className="text-xs text-text-dim mt-1">
						⚠️ このブラウザはブラウザ通知に対応していません。
					</p>
				)}
				{isNotificationGranted() && notificationsEnabled && (
					<p className="text-xs text-green-400 mt-1">
						✅ 通知が有効です。コメント生成後にお知らせします。
					</p>
				)}
			</div>
		</div>
	);
};
